var React = require('react');

function ActivityLogIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12 22c.263 0 .523-.01.78-.03a6.51 6.51 0 0 0 2.4 1.604c-1.012.278-2.079.426-3.18.426-6.627 0-12-5.373-12-12S5.373 0 12 0s12 5.373 12 12c0 1.101-.148 2.168-.426 3.18a6.51 6.51 0 0 0-1.604-2.4c.02-.257.03-.517.03-.78 0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10zm8-4.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0zm2 0a4.48 4.48 0 0 1-.69 2.396l2.397 2.397a1 1 0 0 1-1.414 1.414l-2.397-2.397A4.5 4.5 0 1 1 22 17.5zM13 7a1 1 0 1 0-2 0v4.382l-5.447 2.724a1 1 0 1 0 .894 1.788L13 12.618V7z","fill":"#fff"}));
}

ActivityLogIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ActivityLogIcon;

ActivityLogIcon.default = ActivityLogIcon;
